import {Component, EventEmitter, Input, Output} from "@angular/core";

export class ChartOption {
    type: string;
    icon: string;
    selected: boolean;
}

/**
 *
 */
@Component({
    selector: "wbo-bi-chart-option",
    templateUrl: "./chart-option.component.html",
    styleUrls: ["./chart-option.component.scss"]
})
export class ChartOptionComponent {

    @Input() option: ChartOption;

}
